import React from "react";
import supportJpg from "../../assets/img/youmoni-what-we-do.jpg";
import supportWebp from "../../assets/img/youmoni-what-we-do.webp";
import { HeaderImage, YmHeader } from "../../components/YmHeader";
import useLoadHubspotForms from "../../utils/useLoadHubspotForms";

const ServiceDesk: React.FC<{ match: any }> = (props: any) => {
  const supportImage = props.supportsWebp ? supportWebp : supportJpg;
  return (
    <>
      <YmHeader
        {...props}
        title="Youmoni Servicedesk"
        media={<HeaderImage image={supportImage} />}
      />
      <section>
        {useLoadHubspotForms()}
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="cfc83140-65ba-4387-b54e-e2eb8c639282"
          data-portal-id="5347146"
        ></div>
      </section>
    </>
  );
};

export default ServiceDesk;
